import httpClient from '../http'

export default {
  show() {
      return httpClient.get(`/api/contact`)
  },
}